import mod from "-!./EmployeeDetail.js?vue&type=script&lang=js&"; export default mod; export * from "-!./EmployeeDetail.js?vue&type=script&lang=js&"